import { createAction } from '@reduxjs/toolkit';

const prefix = 'robotic-mowers';

export const updateRoboticMowersMissionsProgress = createAction<{
  items: Array<{
    iprId: string;
    missions: Array<{
      missionId: number;
      progress?: number;
      current: boolean;
    }>;
  }>;
}>(`${prefix}/UPDATE_ROBOTIC_MOWERS_MISSIONS_PROGRESS`);
